import React from 'react';
import PropTypes from 'prop-types';
import { EChartsRenderer } from 'components/charts';
import './Panel.css';
import classNames from 'classnames';
import { ShowHide } from 'components/layout';

export function GraphPanel({
    title,
    options,
    loading = false
}) {
    return (
        <div className='graph-panel'>
            <div className={classNames("spacer-bottom-small", { "bp6-skeleton": loading })}>{title}</div>
            <div className={classNames("graph-panel-chart", { "bp6-skeleton": loading })}>
                <ShowHide
                    evaluator={options != null}
                    show={(
                        <EChartsRenderer
                            option={options}
                        />
                    )}
                />

            </div>
        </div>
    );
}

GraphPanel.propTypes = {
    title: PropTypes.string,
    options: PropTypes.object,
    loading: PropTypes.bool
};